import placementService from 'ApiService/Admin/placementService';
import GenericUserList from '../../../List/GenericUserList';
import { useContext } from 'react';
import { AuthContext } from 'contexts/AuthContext';

const Index = () => {
  const { state } = useContext(AuthContext);
  const userRole = state?.user?.role;

  const columns = [
    { header: 'HR Name', key: 'name' },
    { header: 'Email', key: 'email' },
    ...(userRole === 'superadmin'
      ? [
          { header: 'Branch', key: 'branchName' },
          { header: 'Location', key: 'branchLocation' },
        ]
      : []),
    { header: 'Contact No', key: 'contact' },
    { header: 'Role', key: 'hrRoleDisplay' },
  ];

  const fetchTeachers = async (userId, page) => {
    return await placementService.getAllPlacementOfficer(userId, page);
  };

  const updateTeacher = async (data) => {
    return await placementService.updatePlacementOfficer(data);
  };

  return (
    <GenericUserList
      fetchUsers={fetchTeachers}
      updateUser={updateTeacher}
      userType="Placement"
      columns={columns}
    />
  );
};

export default Index;
